import { useNavigate as useRouterNavigate } from 'react-router-dom';
const useNavigate = () => useRouterNavigate();
export default useNavigate;